import { TextStyle as TextStyleToExtend } from '@tiptap/extension-text-style';

export const TextStyle = TextStyleToExtend.extend({
    priority: 101,
    addAttributes() {
        return {
            ...this.parent?.(),
            class: {
                default: null
            }
        }
    }
})
